import userSession from "../Constant/auth";
import { APP_SERVICES_URL } from "../Constant/constant";

// api.js
const createIncidentAPI = async (requestData) => {
  const { CustID, authHeader, site } = userSession;
  const url = `${APP_SERVICES_URL}/sn-incidents-service/${CustID}/incident`;

  const formattedData = {
    siteName: site.name,
    ...(requestData.eventID !== null && { eventID: requestData.eventID }),
    ...(requestData.incidentDate !== null && { detected: requestData.incidentDate }),
    ...(requestData.type !== null && { type: requestData.type }),
    ...(requestData.pumpNumber !== null && { pumpNumber: requestData.pumpNumber }),
    ...(requestData.licencePlateNumber !== null && { ocr: requestData.licencePlateNumber }),
    ...(requestData.colour !== null && { vehicleColor: requestData.colour }),
    ...(requestData.make !== null && { vehicleMake: requestData.make }),
    ...(requestData.shape !== null && { vehicleShape: requestData.shape }),
    ...(requestData.fuelType !== null && { fuelType: requestData.fuelType }),
    ...(requestData.fuelLitres !== null && { fuelLitres: requestData.fuelLitres }),
    ...(requestData.fuelCost !== null && { fuelValue: requestData.fuelCost }),
    ...(requestData.reference !== null && { fuelReference: requestData.reference }),
    ...(requestData.customerPhoneNumber !== null && { customerPhoneNumber: requestData.customerPhoneNumber }),
    ...(requestData.customerName !== null && { customerName: requestData.customerName }),
    ...(requestData.customerAddress !== null && { customerAddress: requestData.customerAddress }),
    customerGender: 'unknown',
    ...(requestData.employeeName !== null && { employeeName: requestData.employeeName }),
    ...(requestData.note !== null && { note: requestData.note }),
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': authHeader,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData),
      redirect: 'follow', // Follow redirection
      mode: 'cors', // Enable CORS
    });
    if (response.status === 200) {
      const jsonData = await response.json();
      return { success: true, eventID: jsonData.eventID };
    } else {
      const errorText = await response.text();
      let extractedMessage = 'Unknown server error';
      let isDuplicate = false;

      if (/Duplicate incident/i.test(errorText)) {
        extractedMessage = 'Duplicate incident';
        isDuplicate = true;
      }

      return {
        success: false,
        message: extractedMessage,
        status: response.status,
        isDuplicate
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Unknown client error',
      status: null,
      isDuplicate: false
    };
  }
};

export default createIncidentAPI;